import ReactGA from 'react-ga';
import {getCookieValue} from './functions';
import Axios from 'axios';

export const initAnalytics = async (code) =>{
  if(typeof window !== "undefined"){
    if(window){
      if(window.location){
        let locale = await checkLocale();
        console.log(locale)
        let cookieValue = await getCookieValue('_msdyn365___ucc_')
        console.log(cookieValue)
        if(cookieValue){
          console.log('init')
          ReactGA.initialize(code);
          ReactGA.pageview(window.location.pathname + window.location.search);
          localStorage.setItem("lang",locale.lang)
          localStorage.setItem("country",locale.country)
          localStorage.setItem("state",locale.state)
        } else if(locale && locale.lang != 'eu' && locale.lang != 'uk' &&  locale.state != 'CA'){
          let cookieBanners = document.getElementsByClassName('ms-cookie-compliance');
          if(cookieBanners){
            if(cookieBanners[0]){
              cookieBanners[0].style.display = "none";
            }
          }
          ReactGA.initialize(code);
          ReactGA.pageview(window.location.pathname + window.location.search);
          localStorage.setItem("lang",locale.lang)
          localStorage.setItem("country",locale.country)
          localStorage.setItem("state",locale.state)
        }
      } else{
        return false;
      }
    } else{
      return false;
    }
  }
}

export const checkLocale = async() =>{
  var lang;
  var country;
  var state;
  //rest api for location
  var lang;
  if(localStorage.getItem("lang")){
      lang = localStorage.getItem("lang");
      country = localStorage.getItem("country");
      state = localStorage.getItem("state");
      if(typeof window !== "undefined"){
        window.lang = lang;
        window.country = country;
        window.state = state;
      }

      return {
        lang:lang,
        country:country,
        state:state
      }
  }
  else{
   let response = await Axios.get('https://alpine-hosports.herokuapp.com/getUserLocale')
   var country = response.data.geo.country.toLowerCase();
   var state = response.data.geo.region;
   localStorage.setItem('userGeo',JSON.stringify(response.data.geo));
   var language =
   (navigator.languages && navigator.languages[0]) ||
   navigator.language ||
   navigator.userLanguage;
   var languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

   if(country){
     if(country == "de"){
       country = "germany";
     } else if(country == "au"){
       country = "australia";
     } else if(country == 'ca'){
       country = 'canada'
     } else if(lang == 'uk'){
       country = 'uk'
     }
     else{
       country = "us";
     }
   }
   if(language){
     if(language.indexOf("de") != -1){
       lang='de'
     } else if(language == "en-au"){
       lang='au'
     } else{
       lang='en'
     }
   } else{
     lang='en'
   }
   if(typeof window !== "undefined"){
     window.country = country
     window.lang = lang;
     window.state = state;
   }
   return {
     lang:lang,
     country:country,
     state:state
   }
  }
}
